import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

const DimensionsBentoSkeleton = () => {
  return (
    <div className="grid grid-cols-2 gap-4 lg:col-span-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton
          key={index}
          className={cn("bg-gray-200", index === 0 && "col-span-2")}
          style={{ height: "232px" }}
        />
      ))}
    </div>
  );
};

export default DimensionsBentoSkeleton;
